import React, { useState } from "react";
import styled from "@emotion/styled";
import { getLocalStorage } from "../../services/auth";
import { theme } from "../../themes/global";

interface ConsentComponentProps {
  isAgree: boolean;
}

const Wrapper = styled("div")`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(22, 22, 22, 0.5);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Modal = styled("div")`
  width: 80%;
  height: 80%;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;

  span {
    padding: 1rem;
    font-size: 22px;
    opacity: 1;
    border-bottom: 1px solid #ccc;
  }

  .consent {
    padding: 1rem;
    overflow: auto;
    opacity: 0.85;
    flex: 1;
    line-height: 1.1rem;
    ul {
      margin: 1rem 0;
    }
    ul > li {
      list-style: none;
      margin-bottom: 1rem;
    }

    .consent-desc {
      padding: 0 1rem;
    }

    .consent-rect {
      margin-top: 1rem;
    }
  }

  button {
    width: 100%;
    margin: 0;
    padding: 0.8rem;
    background: ${theme.color.primary};
    color: ${theme.color.white};
    border: none;
  }
`;

const ConsentComponent = () => {
  const [isAgree, setIsAgree] = useState(getLocalStorage("isAgree"));
  const handleAgree = () => {
    localStorage.setItem("isAgree", "true");
    setIsAgree("true");
  };

  if (isAgree === "") {
    return (
      <Wrapper>
        <Modal>
          <span>プライバシーポリシー</span>
          <div className="consent">
            学校法人岩崎学園(以降、当学園)が提供する本Webアプリケーションにおける利用情報の取り扱いの概要は以下の通りです。
            本アプリケーションのご利用前にプライバシーポリシーを必ずご確認頂き、内容をご理解のうえ、ご利用ください。
            <ul>
              <li>
                <p>第１条 (利用者情報の取得と目的)</p>
                <div className="consent-desc">
                  当学園が本アプリケーションを通じて収集する個人情報、およびその利用目的は以下の通りです。
                  <p className="consent-rect">■利用する利用者情報</p>
                  <ul style={{ margin: "0 0 0 1rem" }}>
                    <li style={{ margin: 0 }}>①学籍番号</li>
                    <li style={{ margin: 0 }}>
                      ②日々の健康状態(体温・咳や頭痛等の自覚症状)
                    </li>
                    <li style={{ margin: 0 }}>
                      ③メールアドレス(提供有無を選択可能)
                    </li>
                  </ul>
                  <p className="consent-rect">■利用情報の利用目的</p>
                  <p style={{ marginLeft: "1rem" }}>
                    利用者の日々の健康状態を観察することにより感染症への罹患の兆候を把握し、利用者への適切な情報提供を行うため。
                    また、適切な情報提供や指導を行うことにより、他者への感染拡大を防止するため。
                  </p>
                </div>
              </li>
              <li>
                <p>第２条 (利用者情報の第三者提供)</p>
                <div className="consent-desc">
                  本アプリケーションによって収集された情報には当学園に所属する正規の教職員のみがアクセスし、第三者への提供は一切行いません。
                </div>
              </li>
              <li>
                <p>第３条 (利用者情報の取得・蓄積・利用に関する同意)</p>
                <div className="consent-desc">
                  本アプリケーション利用者は、本アプリケーションに初めてアクセスした際に、本プライバシーポリシーの内容を確認し、同意を付与する機会が与えられます。本アプリケーションは本プライバシーポリシーをご確認いただき、内容を理解したうえでご利用ください。
                </div>
              </li>
              <li>
                <p>第４条 (利用者情報の取得停止等)</p>
                <div className="consent-desc">
                  本アプリケーションでは、利用者情報の取得、利用を停止する手段を提供しておりません。これらを停止したい場合には、本アプリケーションへのアクセスを中止してください。
                  なお、中止した時点で既に取得済みの利用者情報については、当学園はは、第1条に定める範囲で引き続き利用することがあります。
                </div>
              </li>
              <li>
                <p>第５条 (プライバシーポリシーの変更)</p>
                <div className="consent-desc">
                  当学園は、本アプリケーションのバージョンアップに伴って、本プライバシーポリシーを変更することがあります。変更内容については、新バージョンのアプリケーションに付随するプライバシーポリシーをご参照ください。
                </div>
              </li>
              <li>
                <p>第６条 (利用者情報の取り扱いに関する問い合わせ窓口)</p>
                <div className="consent-desc">
                  本アプリケーションにおける利用者情報の取扱いに関して、ご意見・ご要望がございましたら、以下の窓口までご連絡くださいますようお願いします。
                </div>
              </li>
            </ul>
            <div className="consent-desc">
              <p>学校法人岩崎学園 ＩＲ推進室</p> <p>健康管理票アプリ担当</p>
              <br />
              <p>住所：〒221-0835</p>
              <p style={{ marginLeft: "1rem" }}>横浜市神奈川区鶴屋町２－１７</p>
              <p>Eメールアドレス : healthcheckapp@gn.iwasaki.ac.jp</p>
            </div>
          </div>
          <button onClick={handleAgree}>同意</button>
        </Modal>
      </Wrapper>
    );
  } else {
    return <></>;
  }
};

export default ConsentComponent;
